'use es6';

import { CUSTOMER_SUCCESS_ALERT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const CustomerSuccessAlert = ObjectDefinitionRecord({
  /* Will have to come back to this once we analyze whether the object should
  be visible for associations */
  enableAsAssociatedType: false,
  objectTypeId: CUSTOMER_SUCCESS_ALERT_TYPE_ID,
  hasAccess: (isUngated, hasScope) => isUngated('SVH:SuccessEnablement:AlertsV1') && hasScope('customer-success-workspace-access'),
  referenceObjectType: 'CUSTOMER_SUCCESS_ALERT_PROPERTIES'
});
export default CustomerSuccessAlert;